import { defineMessages } from "react-intl";

const PREFIX = "Navigation.FooterNavigation";
export default defineMessages({
  usersList: {
    id: `${PREFIX}.usersList`,
    defaultMessage: "User's list",
  },
  departments: {
    id: `${PREFIX}.departments`,
    defaultMessage: "Department's list",
  },
  contactAuthor: {
    id: `${PREFIX}.contactAuthor`,
    defaultMessage: "Contact author",
  },
  disclaimer: {
    id: `${PREFIX}.disclaimer`,
    defaultMessage: "Disclaimer",
  },
  dataProtection: {
    id: `${PREFIX}.dataProtection`,
    defaultMessage: "Data protection",
  },
  credits: {
    id: `${PREFIX}.credits`,
    defaultMessage: "Credits",
  },
  privacy: {
    id: `${PREFIX}.privacy`,
    defaultMessage: "Data privacy",
  },
});
